"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGlAttribute = void 0;
const rc_js_util_1 = require("rc-js-util");
const attribute_state_1 = require("./attribute-state");
/**
 * @public
 * {@inheritDoc IGlAttribute}
 */
class AGlAttribute {
    /**
     * DO NOT MANUALLY SHARE BUFFERS, **USE LINK**!
     */
    constructor(name, buffer, componentsPerVertex, byteOffset = 0, byteStride = 0, normalized = false) {
        this.name = name;
        this.componentsPerVertex = componentsPerVertex;
        this.byteOffset = byteOffset;
        this.byteStride = byteStride;
        this.normalized = normalized;
        this.attributeLocation = null;
        this.type = null;
        this.ptrRequiresSetting = true;
        this.divisor = null;
        this.sharableState = new attribute_state_1.AttributeState(this, buffer);
    }
    onContextLost() {
        this.ptrRequiresSetting = true;
        this.sharableState.buffer.onContextLost();
        this.attributeLocation = null;
        this.type = null;
        this.divisor = null;
    }
    initialize(componentRenderer) {
        componentRenderer.addAttribute(this);
        this.sharableState.buffer.initialize(componentRenderer.context);
        this.attributeLocation = componentRenderer.getAttributeLocation(this.name);
        this.type = this.getGlType(componentRenderer.context);
        if (componentRenderer.isVaoActive()) {
            componentRenderer.context.enableVertexAttribArray(this.attributeLocation);
        }
    }
    getBuffer() {
        return this.sharableState.buffer;
    }
    setBuffer(buffer) {
        this.sharableState.buffer = buffer;
        const linkedAttributes = this.sharableState.attributes;
        for (let i = 0, iEnd = linkedAttributes.length; i < iEnd; ++i) {
            linkedAttributes[i].ptrRequiresSetting = true;
        }
    }
    setData(data, changeId) {
        this.sharableState.buffer.setData(data, changeId);
    }
    setSize(context, byteSize, usage, changeId) {
        this.sharableState.buffer.setSize(context, byteSize, usage, changeId);
    }
    swapBuffer(attribute) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.sharableState.buffer !== attribute.getBuffer(), "attempted to swap buffer with itself");
        const tmp = this.sharableState.buffer;
        this.setBuffer(attribute.getBuffer());
        attribute.setBuffer(tmp);
    }
    setSubBufferData(componentRenderer, byteOffset, data, changeId, modificationId) {
        this.sharableState.buffer.setSubBufferData(componentRenderer.context, byteOffset, data, changeId, modificationId);
    }
    setOffset(byteOffset) {
        if (this.byteOffset !== byteOffset) {
            this.ptrRequiresSetting = true;
            this.byteOffset = byteOffset;
        }
    }
    setStride(byteStride) {
        if (this.byteStride !== byteStride) {
            this.ptrRequiresSetting = true;
            this.byteStride = byteStride;
        }
    }
    // FIXME this is missing bind constant / default
    bindTransform(componentRenderer, index) {
        this.sharableState.buffer.bindTransform(componentRenderer.context, index);
    }
    bindArray(componentRenderer, usage = componentRenderer.context.DYNAMIC_DRAW) {
        const context = componentRenderer.context;
        if (this.attributeLocation == null || this.type == null) {
            DEBUG_MODE && rc_js_util_1._Debug.error(`expected attribute ${this.name} to be initialized`);
            return;
        }
        if (componentRenderer.isVaoActive()) {
            if (this.sharableState.buffer.isDirty || this.ptrRequiresSetting) {
                this.sharableState.buffer.bindArray(context, usage);
            }
            if (this.ptrRequiresSetting) {
                this.setAttributePtr(context, this.attributeLocation, this.type);
            }
        }
        else {
            this.sharableState.buffer.bindArray(context, usage);
            context.enableVertexAttribArray(this.attributeLocation);
            this.setAttributePtr(context, this.attributeLocation, this.type);
        }
        this.ptrRequiresSetting = false;
    }
    bindArrayInstanced(componentRenderer, divisor, usage) {
        if (this.attributeLocation == null) {
            DEBUG_MODE && rc_js_util_1._Debug.error(`expected attribute ${this.name} to be initialized`);
            return;
        }
        this.bindArray(componentRenderer, usage);
        if (componentRenderer.isVaoActive()) {
            if (this.divisor === divisor) {
                return;
            }
            this.divisor = divisor;
        }
        if (componentRenderer.isGl2) {
            componentRenderer.context.vertexAttribDivisor(this.attributeLocation, divisor);
        }
        else {
            componentRenderer.extensions.ANGLE_instanced_arrays.vertexAttribDivisorANGLE(this.attributeLocation, divisor);
        }
    }
    reset(componentRenderer) {
        if (componentRenderer.isVaoActive()) {
            return;
        }
        if (this.attributeLocation == null) {
            DEBUG_MODE && rc_js_util_1._Debug.error(`expected attribute ${this.name} to be initialized`);
            return;
        }
        if (componentRenderer.isGl2) {
            componentRenderer.context.vertexAttribDivisor(this.attributeLocation, 0);
        }
        else if (componentRenderer.extensions.ANGLE_instanced_arrays != null) {
            componentRenderer.extensions.ANGLE_instanced_arrays.vertexAttribDivisorANGLE(this.attributeLocation, 0);
        }
        componentRenderer.context.disableVertexAttribArray(this.attributeLocation);
    }
    link(sharedState) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.attributeLocation == null, "link attributes before using programs");
        this.sharableState = sharedState;
        sharedState.addAttribute(this);
    }
    getSharableState() {
        return this.sharableState;
    }
    setAttributePtr(context, attributeLocation, type) {
        context.vertexAttribPointer(attributeLocation, this.componentsPerVertex, type, this.normalized, this.byteStride, this.byteOffset);
    }
}
exports.AGlAttribute = AGlAttribute;
//# sourceMappingURL=a-gl-attribute.js.map